module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (typeof(_vm.notifications.data) != 'undefined') ? _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "icon-avatar",
    attrs: {
      "id": "dropdown",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "img-nav",
    attrs: {
      "src": "/static/img/notification.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "notification-cant"
  }, [_c('span', [_vm._v(_vm._s(_vm.unreadCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu drop-edit",
    attrs: {
      "aria-labelledby": "dropdown"
    }
  }, [_c('div', {
    staticClass: "notification-item-container"
  }, [_c('div', {
    staticClass: "notification-content"
  }, _vm._l((_vm.notifications.data), function(notification) {
    return _c('notification-item', {
      key: notification.id,
      attrs: {
        "notification": notification
      },
      on: {
        "readSuccess": _vm.discountReadNotification
      }
    })
  }), 1), _vm._v(" "), (!_vm.notifications.data.length) ? _c('div', {
    staticClass: "no-notifications"
  }, [_c('span', [_vm._v("No tienes nuevas notificaciones")])]) : (_vm.nextNotificationsUrl != null) ? _c('div', {
    staticClass: "notification-more",
    on: {
      "click": _vm.getMoreNotifications
    }
  }, [_c('span', [_vm._v("Ver más")])]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c0f0841"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/NotificationsMenu.vue
// module id = 1890
// module chunks = 1